(() => {
  const browsstampKey = 'marketkissBrowsstampOfferExpiresAtV1';
  const path = location.pathname;
  let saved = null;
  try { saved = localStorage.getItem(browsstampKey); } catch {}
  const isBrowsstampPage = /\/products\/(?:browsstamp|browiso-stamp)\/?$/.test(path);
  let browsstampCart = false;
  try {
    if (/\/products\/[^/]+\/?$/.test(path)) sessionStorage.setItem('marketkissBrowsstampCartContext', isBrowsstampPage ? '1' : '0');
    browsstampCart = sessionStorage.getItem('marketkissBrowsstampCartContext') === '1';
  } catch {}
  const isBrowsstamp = isBrowsstampPage || (/\/cart\/?$/.test(path) && browsstampCart && saved !== null);
  globalThis.marketkissBrowsstampOfferActive = isBrowsstamp;
  const storageKey = isBrowsstamp ? browsstampKey : 'marketkissDuoOfferExpiresAt';
  const duration = (isBrowsstamp ? 30 : 25) * 60 * 1000;
  let expiresAt = Date.now() + duration;
  try {
    const storage = isBrowsstamp ? localStorage : sessionStorage;
    const stored = Number(storage.getItem(storageKey));
    if (isBrowsstamp ? Number.isFinite(stored) && stored > 0 : stored > Date.now()) expiresAt = stored;
    storage.setItem(storageKey, String(expiresAt));
  } catch {}
  let timer;
  const update = () => {
    if (!isBrowsstamp && expiresAt <= Date.now()) {
      expiresAt = Date.now() + duration;
      try { sessionStorage.setItem(storageKey, String(expiresAt)); } catch {}
    }
    const seconds = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
    const value = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    document.querySelectorAll('[data-offer-countdown]').forEach(node => {
      node.textContent = value;
      if (isBrowsstamp && /\/cart\/?$/.test(path)) {
        const cartWrap = node.closest('.mk-page-offer [data-offer-countdown-wrap]');
        if (cartWrap && !cartWrap.dataset.browsstampLabel) {
          for (const child of cartWrap.childNodes) {
            if (child.nodeType === 3 && child.textContent.trim()) child.textContent = 'Order in the next ';
          }
          cartWrap.dataset.browsstampLabel = 'true';
        }
      }
      if (isBrowsstamp && seconds === 0) {
        const wrap = node.closest('[data-offer-countdown-wrap], [data-sticky-deadline]');
        if (wrap) { wrap.hidden = true; wrap.style.display = 'none'; }
      }
    });
    if (isBrowsstamp && seconds === 0) clearInterval(timer);
  };
  globalThis.marketkissOfferCountdownRefresh = update;
  const start = () => { timer = setInterval(update, 1000); update(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('storage', event => {
    if (isBrowsstamp && event.key === browsstampKey && Number(event.newValue) > 0) { expiresAt = Number(event.newValue); update(); }
  });
})();

globalThis.BrowisoCheckout = class {
  static money(amount, currency, locale = 'en') {
    const symbols = { AUD: 'A$', NZD: 'NZ$', CAD: 'CA$', USD: '$', GBP: '£', EUR: '€' };
    const value = Math.round(Number(amount) / 100);
    const parts = new Intl.NumberFormat(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).formatToParts(value);
    return parts.map(part => part.type === 'currency' ? (symbols[currency] || part.value) : part.value).join('');
  }
  static calendarDate(country, offset, now = new Date()) {
    const zones = { AU: 'Australia/Sydney', NZ: 'Pacific/Auckland', US: 'America/New_York', CA: 'America/Toronto', GB: 'Europe/London', IE: 'Europe/Dublin' };
    const parts = new Intl.DateTimeFormat('en', { timeZone: zones[country] || 'UTC', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const part = type => Number(parts.find(value => value.type === type).value);
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day') + offset, 12));
  }
  constructor(config, request = globalThis.fetch.bind(globalThis)) {
    this.config = config; this.request = request; this.busy = false;
  }
  async json(url, body) {
    const contextualUrl = new URL(url, globalThis.location.origin);
    contextualUrl.searchParams.set('country', this.config.country);
    const response = await this.request(contextualUrl.pathname + contextualUrl.search, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || this.config.messages.error);
    return result;
  }
  cart() { return this.json(this.config.cartUrl + '.js'); }
  offerPrice(count, rawPrice) {
    const final = this.config.offerPrices[count - 1];
    const base = this.config.basePrices[count - 1];
    if (rawPrice !== final && rawPrice !== base) throw new Error(this.config.messages.price);
    return final;
  }
  properties(shades, previous = {}) {
    const c = this.config;
    const result = { ...previous };
    ['Shades', 'Offer', 'When purchased individually', 'Bundle discount', 'Shipping Protection', 'Advanced Brows e-book'].forEach(key => delete result[key]);
    result._browiso_selection = 'offer-v3';
    result._browiso_shades = shades.join('|');
    if (shades.length === 3) result[c.strings.protection + ' + ' + c.strings.ebook] = c.included;
    return result;
  }
  async clean(cart) {
    for (const item of this.ownItems(cart)) {
      if (item.properties?._browiso_selection === 'offer-v3') continue;
      cart = await this.json(this.config.cartUrl + '/change.js', { id: item.key, quantity: item.quantity, properties: this.properties(this.selection(item), item.properties) });
    }
    return cart;
  }
  selection(item) {
    const match = Object.entries(this.config.variantMap).find(([, id]) => Number(id) === Number(item.variant_id));
    return match ? match[0].split('|') : null;
  }
  ownItems(cart) { return cart.items.filter(item => this.selection(item)); }
  protections(cart) { return cart.items.filter(item => Number(item.variant_id) === Number(this.config.protectionVariantId)); }
  supports(cart) { return this.config.marketSupported && cart?.currency === this.config.currency; }
  shippingSaving(cart, rate) {
    return this.supports(cart) && rate === 0 && this.ownItems(cart).some(item => this.selection(item).length > 1) ? Math.max(0, this.config.shippingReference || 0) : 0;
  }
  checkMarket(cart) { if (!this.supports(cart)) throw new Error(this.config.messages.market); }
  async product(count) { return this.json(this.config.productsUrl + this.config.productHandles[count - 1] + '.js'); }
  async candidate(count, currentShades) {
    if (!(this.config.enabledKitCounts || [1, 2, 3]).includes(count)) throw new Error(this.config.messages.unavailable);
    const product = await this.product(count);
    const prefix = currentShades.slice(0, count);
    const candidates = Object.entries(this.config.variantMap).filter(([key]) => { const s = key.split('|'); return s.length === count && prefix.every((x, i) => s[i] === x); });
    for (const [key, id] of candidates) {
      const variant = product.variants.find(v => Number(v.id) === Number(id) && v.available);
      if (variant) return { id, shades: key.split('|'), price: this.offerPrice(count, variant.price) };
    }
    throw new Error(this.config.messages.unavailable);
  }
  async shipping(cart) {
    this.checkMarket(cart);
    const sample = this.config.shippingAddress;
    if (!sample) throw new Error(this.config.messages.shipping);
    const country = this.config.country;
    const address = new URLSearchParams({ 'shipping_address[country]': sample.country, 'shipping_address[province]': cart.attributes?.[country + ' state'] || sample.province, 'shipping_address[zip]': cart.attributes?.[country + ' postcode'] || sample.zip });
    const result = await this.json(this.config.cartUrl + '/shipping_rates.json?' + address);
    const prices = (result.shipping_rates || []).map(rate => Math.round(Number(rate.price) * 100)).filter(Number.isFinite);
    if (!prices.length) throw new Error(this.config.messages.shipping);
    return Math.min(...prices);
  }
  async quote(cart, nextCount, shippingRate) {
    const items = this.ownItems(cart);
    if (items.length !== 1 || items[0].quantity !== 1) return null;
    const item = items[0], shades = this.selection(item), next = await this.candidate(nextCount, shades);
    const shipping = shippingRate ?? await this.shipping(cart);
    // The next native bundle qualifies for the market's configured free tracked rate.
    // Other products keep their own shipping; do not promise an exact upgrade on mixed carts.
    if (cart.items.some(i => !this.selection(i) && Number(i.variant_id) !== Number(this.config.protectionVariantId))) return null;
    if ((cart.cart_level_discount_applications || []).length || item.final_line_price !== this.config.offerPrices[shades.length - 1]) return null;
    const removedProtection = nextCount === 3 ? this.protections(cart).reduce((sum, i) => sum + i.final_line_price, 0) : 0;
    const currentTotal = cart.total_price + shipping;
    const nextTotal = cart.total_price - item.final_line_price - removedProtection + next.price;
    return { ...next, shipping, currentTotal, nextTotal, delta: nextTotal - currentTotal };
  }
  async prepare(count, protection, shades, initialCart) {
    if (this.busy || globalThis.browOfferMutationBusy) return null;
    this.busy = globalThis.browOfferMutationBusy = true;
    const c = this.config;
    let snapshot, touched = false;
    try {
      if (!(c.enabledKitCounts || [1, 2, 3]).includes(count) || shades.length !== count || shades.some(s => !c.shades[s])) throw new Error(c.messages.error);
      const id = c.variantMap[shades.join('|')];
      let [product, cart] = await Promise.all([this.product(count), initialCart ? Promise.resolve(initialCart) : this.cart()]);
      const variant = product.variants.find(v => Number(v.id) === Number(id));
      if (!variant?.available) throw new Error(c.messages.unavailable);
      this.offerPrice(count, variant.price);
      this.checkMarket(cart);
      const kits = this.ownItems(cart);
      if (kits.some(i => i.quantity !== 1) || kits.length > 1) throw new Error(c.messages.existing);
      snapshot = [...kits, ...this.protections(cart)];
      const properties = this.properties(shades);
      const paidProtection = count < 3 && protection;
      if (paidProtection) {
        const p = await this.json(c.productsUrl + c.protectionHandle + '.js');
        if (!p.variants.some(v => Number(v.id) === Number(c.protectionVariantId) && v.available && v.price === c.protectionPrice)) throw new Error(c.messages.price);
      }
      const already = kits.length === 1 && Number(kits[0].variant_id) === Number(id) && kits[0].properties?._browiso_selection === 'offer-v3';
      const remove = snapshot.filter(i => this.selection(i) ? !already : !paidProtection || this.protections(cart).length !== 1 || i.quantity !== 1);
      if (remove.length) {
        touched = true;
        cart = await this.json(c.cartUrl + '/update.js', { updates: Object.fromEntries(remove.map(i => [i.key, 0])) });
      }
      const add = [];
      if (!already) add.push({ id, quantity: 1, properties });
      if (paidProtection && !this.protections(cart).length) add.push({ id: c.protectionVariantId, quantity: 1, properties: { _browiso_selection: 'offer-v2' } });
      if (add.length) { touched = true; await this.json(c.cartUrl + '/add.js', { items: add }); cart = await this.cart(); }
      this.checkMarket(cart);
      const finalKits = this.ownItems(cart), finalProtection = this.protections(cart);
      if (finalKits.length !== 1 || Number(finalKits[0].variant_id) !== Number(id) || finalKits[0].quantity !== 1 || finalKits[0].final_line_price !== c.offerPrices[count - 1]) throw new Error(c.messages.price);
      if (finalProtection.length !== (paidProtection ? 1 : 0) || (paidProtection && (finalProtection[0].quantity !== 1 || finalProtection[0].final_line_price !== c.protectionPrice))) throw new Error(c.messages.price);
      return cart;
    } catch (error) {
      if (touched && snapshot) {
        try {
          const current = await this.cart();
          const own = [...this.ownItems(current), ...this.protections(current)];
          if (own.length) await this.json(c.cartUrl + '/update.js', { updates: Object.fromEntries(own.map(i => [i.key, 0])) });
          if (snapshot.length) await this.json(c.cartUrl + '/add.js', { items: snapshot.map(i => ({ id: i.variant_id, quantity: i.quantity, properties: i.properties })) });
        } catch { throw new Error(c.messages.recovery); }
      }
      throw error;
    } finally { this.busy = globalThis.browOfferMutationBusy = false; }
  }
};

(() => {
  const init = () => {
    const dialog = document.querySelector('[data-source-cart]');
    const configElement = document.querySelector('[data-source-cart-config]');
    if (!dialog || !configElement || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const config = JSON.parse(configElement.textContent);
    const strings = config.strings;
    if (globalThis.marketkissBrowsstampOfferActive) strings.offerEndsIn = document.body.dataset.orderWithin || 'Order in the next';
    const refreshDispatch = () => {
      const target = dialog.querySelector('[data-cart-dispatch-date]');
      if (!target) return;
      const tomorrow = globalThis.BrowisoCheckout.calendarDate(config.country, 1);
      target.textContent = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(tomorrow);
    };
    refreshDispatch();
    window.addEventListener('pageshow', refreshDispatch);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshDispatch(); });
    window.setInterval(refreshDispatch, 60000);
    const body = dialog.querySelector('[data-cart-content]');
    const footer = dialog.querySelector('[data-cart-footer]');
    const totals = dialog.querySelector('[data-cart-totals]');
    const status = dialog.querySelector('[data-cart-status]');
    const error = dialog.querySelector('[data-cart-error]');
    const checkout = dialog.querySelector('[data-cart-checkout]');
    const closeButton = dialog.querySelector('[data-cart-close]');
    const priority = dialog.querySelector('[data-cart-priority]');
    const priorityLines = () => (cart?.items || []).filter((item) => String(item.variant_id) === priority?.dataset.variantId && item.properties?._browfi_addon === 'priority');
    const syncPriority = () => {
      if (!priority) return;
      priority.disabled = busy || !cart?.items.length || priority.dataset.addonPurchasable !== 'true';
      priority.checked = priorityLines().length > 0;
    };
    let busy = false;
    let cart = null;
    let opener = null;
    let changed = false;
    let refreshAfterBusy = false;
    const node = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    };
    const money = (amount) => globalThis.BrowisoCheckout.money(amount, cart?.currency || config.currency || 'USD', document.documentElement.lang || 'en');
    const icon = (name) => {
      const paths = { trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 10v7M14 10v7', book: 'M4 4h7l1 2 1-2h7v15h-7l-1 1-1-1H4zM12 6v14', tag: 'M3 3h8l10 10-8 8L3 11zM7 7h.01' };
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', '20'); svg.setAttribute('height', '20'); svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', paths[name]); path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.7'); path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round'); svg.append(path);
      return svg;
    };
    const safeUrl = (value) => {
      if (typeof value !== 'string' || !value.trim()) return '';
      try {
        const url = new URL(value, location.origin);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
      } catch { return ''; }
    };
    const setError = (message = '') => {
      error.textContent = message;
      error.hidden = !message;
    };
    const setBusy = (value) => {
      busy = value;
      dialog.setAttribute('aria-busy', String(value));
      dialog.querySelectorAll('[data-cart-mutate], [data-cart-checkout]').forEach((control) => { control.disabled = value || control.dataset.cartLimit === 'true'; });
      status.textContent = value ? strings.loading : '';
      syncPriority();
    };
    const updateCount = (count) => {
      document.querySelectorAll('.header__icon--cart, .mk-cart').forEach((link) => {
        link.setAttribute('aria-label', `${strings.title} (${count})`);
        let bubble = link.querySelector('.cart-count-bubble');
        if (!bubble) {
          bubble = node('div', 'cart-count-bubble');
          bubble.setAttribute('aria-hidden', 'true');
          link.append(bubble);
        }
        bubble.textContent = String(count);
        bubble.hidden = !count;
        bubble.style.display = count ? '' : 'none';
      });
      document.querySelectorAll('[data-cart-count]').forEach((element) => { element.textContent = String(count); });
    };
    const makeButton = (text, label, action) => {
      const button = node('button', '', text);
      button.type = 'button';
      button.dataset.cartMutate = '';
      button.setAttribute('aria-label', label);
      button.addEventListener('click', action);
      return button;
    };

    const offerConfigNode = document.querySelector('[data-offer-test-config]');
    const offerConfig = offerConfigNode ? JSON.parse(offerConfigNode.textContent) : null;
    const offer = offerConfig ? new globalThis.BrowisoCheckout(offerConfig) : null;
    const offerText = offerConfig ? offerConfig.strings : {};
    let renderGeneration = 0;
    const offerActive = () => offer && offer.supports(cart);
    const comparisonSaving = snapshot => snapshot.items.reduce((sum, item) => {
      const shades = offerActive() ? offer.selection(item) : null;
      const comparison = shades?.length > 1 ? offerConfig.basePrices[0] * shades.length * item.quantity : item.original_line_price;
      return sum + Math.max(0, comparison - item.final_line_price);
    }, 0);
    const switchOffer = async (count, paid, selectedShades) => {
      if (busy) return;
      setError(); setBusy(true);
      try {
        const current = offer.ownItems(cart)[0];
        const candidate = selectedShades ? { shades: selectedShades } : await offer.candidate(count, offer.selection(current));
        const result = await offer.prepare(count, count < 3 && paid, candidate.shades);
        if (result) { changed = true; render(result); }
      } catch (failure) {
        try { render(await offer.cart()); } catch {}
        setError(failure.message);
      } finally { setBusy(false); }
    };
    const decorateOffer = async (generation) => {
      if (!offerActive() || !cart.items.length) return;
      const snapshot = cart;
      try {
        const rate = await offer.shipping(snapshot);
        if (generation !== renderGeneration) return;
        const row = totals.querySelector('[data-shipping-pending]') || node('p', 'source-cart-total-row');
        row.replaceChildren();
        row.removeAttribute('data-shipping-pending');
        const shippingValue = node('span');
        if (rate === 0 && offerConfig.shippingReference > 0 && offer.ownItems(snapshot).some(i => offer.selection(i).length > 1)) shippingValue.append(node('s', '', money(offerConfig.shippingReference) + ' '));
        shippingValue.append(node('strong', '', rate === 0 ? offerText.free : money(rate)));
        row.append(node('span', '', strings.shipping), shippingValue);
        const grand = totals.querySelector('.is-total');
        const savingsRow = totals.querySelector('.is-savings');
        (savingsRow || grand).before(row);
        grand.firstChild.textContent = strings.total + ' (' + snapshot.currency + ')';
        grand.lastChild.textContent = money(snapshot.total_price + rate);
        const shippingSaving = offer.shippingSaving(snapshot, rate);
        const freeBundleShipping = shippingSaving > 0;
        if (savingsRow && shippingSaving > 0) {
          savingsRow.firstChild.textContent = strings.savingsShipping;
          savingsRow.lastChild.textContent = money(comparisonSaving(snapshot) + shippingSaving);
        }
        const benefit = dialog.querySelector('[data-cart-benefit]');
        benefit.textContent = '';
        if (freeBundleShipping) {
          const label = node('strong', 'mk-cart-offer-value', strings.promotionValue);
          const countdownLine = node('span', 'mk-cart-countdown-line', strings.offerEndsIn + ' ');
          countdownLine.dataset.offerCountdownWrap = '';
          const countdown = node('b', 'mk-cart-countdown', globalThis.marketkissBrowsstampOfferActive ? '30:00' : '25:00');
          countdown.dataset.offerCountdown = '';
          countdownLine.append(countdown);
          benefit.append(label, countdownLine);
          globalThis.marketkissOfferCountdownRefresh?.();
        }
        benefit.hidden = !freeBundleShipping;
        dialog.querySelector('[data-cart-note]').textContent = strings.deliveryNote || offerText.shippingEstimate;
        const kits = offer.ownItems(snapshot);
        if (kits.length !== 1 || kits[0].quantity !== 1) return;
        const item = kits[0], count = offer.selection(item).length;
        if (!(offerConfig.enabledKitCounts || [1, 2, 3]).includes(count + 1)) return;
        const quote = await offer.quote(snapshot, count + 1, rate);
        if (generation !== renderGeneration || !quote) return;
        const upsell = node('div', 'offer-cart-upgrade');
        const template = count === 1 ? (quote.shipping === 0 ? offerText.secondFree : offerText.second) : offerText.third;
        upsell.append(node('p', '', template.replace('__DELTA__', money(quote.delta))));
        if (count === 2 && offer.protections(snapshot).length) upsell.append(node('small', '', offerText.protectionSaving));
        const button = makeButton(count === 1 ? offerText.duo : offerText.trio, count === 1 ? offerText.duo : offerText.trio, () => switchOffer(count + 1, offer.protections(cart).length > 0, quote.shades));
        button.className = 'button'; button.disabled = busy; upsell.append(button);
        const controls = body.querySelector('.offer-cart-controls');
        if (controls) controls.before(upsell); else body.append(upsell);
      } catch (failure) {
        if (generation === renderGeneration) {
          totals.querySelector('[data-shipping-pending]')?.remove();
          const grand = totals.querySelector('.is-total');
          if (grand) grand.lastChild.textContent = money(snapshot.total_price);
          dialog.querySelector('[data-cart-note]').textContent = failure.message;
        }
      }
    };
    const appendOfferControls = () => {
      if (!offerActive()) return;
      const kits = offer.ownItems(cart);
      if (kits.length !== 1 || kits[0].quantity !== 1) return;
      const kit = kits[0], count = offer.selection(kit).length, paid = offer.protections(cart).length > 0;
      const controls = node('div', 'offer-cart-controls');
      const cover = node('div', 'offer-cart-protection' + (count === 3 || paid ? ' is-included' : ''));
      const image = node('img'); image.src = config.protectionImage; image.width = 40; image.height = 40; image.alt = ''; cover.append(image);
      const copy = node('div', 'offer-cart-cover-copy');
      copy.append(node('strong', '', offerText.protection));
      const actions = node('div', 'offer-cart-cover-actions');
      const price = node('p', 'offer-cart-cover-price');
      if (count === 3) price.append(node('s', '', money(offerConfig.protectionPrice)), node('strong', '', ' ' + offerText.included));
      else price.textContent = money(offerConfig.protectionPrice);
      actions.append(price);
      const help = node('p', 'offer-cart-cover-description', offerText.protectionHelp);
      help.id = 'OfferCartProtectionDescription';
      const shortHelp = node('p', 'offer-cart-cover-short', strings.protectionShort);
      const disclosure = node('details', 'offer-cart-cover-details');
      disclosure.append(node('summary', '', strings.protectionDetails), help);
      cover.append(copy, actions, shortHelp, disclosure);
      if (count !== 3) {
        const toggle = node('input'); toggle.type = 'checkbox'; toggle.checked = paid; toggle.dataset.cartMutate = '';
        toggle.setAttribute('aria-label', offerText.protection + ' — ' + money(offerConfig.protectionPrice));
        toggle.setAttribute('aria-describedby', help.id);
        toggle.addEventListener('change', () => switchOffer(count, toggle.checked, offer.selection(kit)));
        const toggleLabel = node('label', 'offer-cart-cover-toggle');
        const toggleTrack = node('span'); toggleTrack.setAttribute('aria-hidden', 'true');
        toggleLabel.append(toggle, toggleTrack); actions.append(toggleLabel);
      }
      if (count === 3) {
        const gifts = node('section', 'mk-cart-gifts');
        gifts.setAttribute('aria-label', strings.bonuses);
        gifts.append(node('h3', 'mk-cart-gift-heading', strings.bonuses));
        const ebook = node('div', 'mk-cart-gift');
        const book = node('span', 'mk-cart-book'); book.append(icon('book'));
        const bookCopy = node('div'); bookCopy.append(node('strong', '', offerText.ebook), node('small', '', strings.digitalGuide));
        ebook.append(book, bookCopy, node('b', 'mk-cart-free', offerText.free));
        gifts.append(cover, ebook); controls.append(gifts);
      } else controls.append(cover);
      body.append(controls);
    };

    const render = (result, focusKey) => {
      const generation = ++renderGeneration;
      cart = result;
      syncPriority();
      updateCount(cart.item_count);
      const physicalCount = cart.items.reduce((sum, item) => sum + (Number(item.variant_id) === Number(config.protectionVariantId) ? 0 : (offerActive() ? (offer.selection(item)?.length || 1) : 1) * item.quantity), 0);
      dialog.querySelector('#SourceCartTitle').textContent = strings.title + ' (' + physicalCount + ')';
      dialog.querySelector('[data-cart-benefit]').hidden = true;
      refreshDispatch();
      dialog.querySelector('[data-cart-dispatch]').hidden = !offerActive() || !offer.ownItems(cart).length;
      body.replaceChildren();
      totals.replaceChildren();
      footer.hidden = !cart.items.length;
      const guarantee = dialog.querySelector('[data-money-back-guarantee]');
      if (guarantee) guarantee.hidden = !offer?.ownItems(cart).length;
      if (!cart.items.length) {
        const empty = node('div', 'source-cart-empty');
        empty.append(node('h3', '', strings.empty));
        const continueButton = node('button', 'button', strings.continue);
        continueButton.type = 'button';
        continueButton.addEventListener('click', () => dialog.close());
        empty.append(continueButton);
        body.append(empty);
      }
      cart.items.forEach((item, index) => {
        if (offerActive() && offer.ownItems(cart).length === 1 && Number(item.variant_id) === Number(config.protectionVariantId)) return;
        const kitShades = offerActive() ? offer.selection(item) : null;
        const article = node('article', 'source-cart-line');
        const kitImage = config.kitImages?.[offer?.selection(item)?.length] || '';
        const imageUrl = safeUrl(kitImage || item.featured_image?.url || item.image || '');
        if (imageUrl) {
          const image = node('img', 'source-cart-image' + (kitImage ? ' mk-cart-kit-image' : ''));
          image.src = imageUrl;
          image.alt = kitImage ? item.product_title : (item.featured_image?.alt || item.product_title);
          image.width = 80;
          image.height = 80;
          article.append(image);
        } else article.append(node('span'));
        const details = node('div', 'mk-cart-detail');
        const heading = node('h3', 'source-cart-name');
        const service = Number(item.variant_id) === Number(config.protectionVariantId);
        if (service) heading.textContent = item.product_title;
        else {
          const link = node('a', '', item.product_title);
          let itemUrl = safeUrl(item.url) || config.cartUrl;
          const handle = new URL(itemUrl, location.origin).pathname.split('/').pop();
          if (['browiso-duo-trio', 'browiso-trio'].includes(handle) && config.kitUrl) {
            const target = new URL(config.kitUrl, location.origin);
            target.searchParams.set('kit', handle === 'browiso-trio' ? '3' : '2');
            target.searchParams.set('bundle_variant', item.variant_id);
            itemUrl = target.href;
          }
          link.href = itemUrl;
          heading.append(link);
        }
        details.append(heading);
        if (kitShades) {
          details.append(node('p', 'offer-cart-kit-count', offerConfig.offerNames[kitShades.length - 1] + ' · ' + String(kitShades.length) + ' ' + (kitShades.length === 1 ? strings.kit : strings.kits)));
          const groups = new Map();
          kitShades.forEach(shade => groups.set(shade, (groups.get(shade) || 0) + 1));
          const shadeList = node('ul', 'offer-cart-shades');
          groups.forEach((quantity, shade) => shadeList.append(node('li', '', offerConfig.shades[shade].name + (quantity > 1 ? ' × ' + quantity : ''))));
          details.append(shadeList);
        } else if (!item.properties?.Shades && item.variant_title && item.variant_title !== 'Default Title') details.append(node('p', 'source-cart-options', item.variant_title));
        if (item.selling_plan_allocation?.selling_plan?.name) details.append(node('p', 'source-cart-plan', item.selling_plan_allocation.selling_plan.name));
        const properties = node('dl', 'source-cart-properties');
        Object.entries(item.properties || {}).forEach(([name, value]) => {
          if (name.startsWith('_') || value === null || value === '') return;
          if (kitShades && ['Shades', 'Offer', 'When purchased individually', 'Bundle discount', 'Shipping Protection', 'Advanced Brows e-book', offerText.protection + ' + ' + offerText.ebook].includes(name)) return;
          properties.append(node('dt', '', `${name}: `), node('dd', '', String(value)));
        });
        details.append(properties);
        const price = node('p', 'source-cart-price');
        const comparisonPrice = kitShades?.length > 1 ? offerConfig.basePrices[0] * kitShades.length * item.quantity : item.original_line_price;
        if (comparisonPrice > item.final_line_price) price.append(node('s', '', money(comparisonPrice)));
        price.append(node('span', '', money(item.final_line_price)));
        const priceColumn = node('div', 'mk-cart-prices');
        priceColumn.append(price);
        details.append(priceColumn);
        if (kitShades && item.quantity === 1 && kitShades.length > 1) {
          details.append(node('p', 'mk-cart-unit-price', money(item.final_line_price / kitShades.length) + ' ' + offerText.perKit));
          price.querySelector('s')?.setAttribute('aria-label', strings.compareCart);
        }
        const discounts = node('ul', 'source-cart-discounts');
        (item.line_level_discount_allocations || []).forEach((allocation) => discounts.append(node('li', '', `${allocation.discount_application.title} (−${money(allocation.amount)})`)));
        if (!kitShades) details.append(discounts);
        const actions = node('div', 'source-cart-actions');
        const quantity = node('div', 'source-cart-quantity');
        const input = node('input');
        input.type = 'number';
        input.min = '0';
        input.step = '1';
        input.inputMode = 'numeric';
        input.value = String(item.quantity);
        input.dataset.cartMutate = '';
        input.dataset.cartKey = item.key;
        input.setAttribute('aria-label', `${strings.quantity}: ${item.product_title} ${item.variant_title || ''}`);
        input.addEventListener('change', () => {
          const quantityValue = Number(input.value);
          if (input.value.trim() === '' || !Number.isSafeInteger(quantityValue) || quantityValue < 0) {
            setError(strings.invalidQuantity);
            input.value = String(item.quantity);
            return;
          }
          if (quantityValue !== item.quantity) change(item.key, quantityValue, index);
        });
        if (!service) quantity.append(makeButton('−', `${strings.decrease}: ${item.product_title}`, () => change(item.key, item.quantity - 1, index)), input, makeButton('+', `${strings.increase}: ${item.product_title}`, () => change(item.key, item.quantity + 1, index)));
        const remove = makeButton(strings.remove, `${strings.remove}: ${item.product_title} ${item.variant_title || ''}`, () => change(item.key, 0, index));
        remove.className = 'source-cart-remove';
        remove.replaceChildren(icon('trash'));
        remove.title = strings.remove;
        if (kitShades && item.quantity === 1) {
          const kitCount = kitShades.length;
          const kitQuantity = node('div', 'source-cart-quantity mk-kit-quantity');
          const minus = makeButton('−', strings.decrease + ': ' + strings.kits, () => kitCount > 1 ? switchOffer(kitCount - 1, offer.protections(cart).length > 0) : change(item.key, 0, index));
          const plus = makeButton('+', strings.increase + ': ' + strings.kits, () => { if ((offerConfig.enabledKitCounts || [1, 2, 3]).includes(kitCount + 1)) switchOffer(kitCount + 1, offer.protections(cart).length > 0); });
          if (!(offerConfig.enabledKitCounts || [1, 2, 3]).includes(kitCount + 1)) { plus.disabled = true; plus.dataset.cartLimit = 'true'; }
          kitQuantity.append(minus, node('span', 'mk-kit-number', String(kitCount)), plus);
          actions.append(kitQuantity);
        } else if (!service) actions.append(quantity);
        actions.append(remove);
        details.append(actions);
        article.append(details);
        body.append(article);
      });
      appendOfferControls();
      const totalRow = (label, amount, className = '') => {
        const row = node('p', `source-cart-total-row ${className}`);
        row.append(node('span', '', label), node('span', '', amount));
        totals.append(row);
        return row;
      };
      totalRow(strings.subtotal, money(cart.items_subtotal_price));
      (cart.cart_level_discount_applications || []).forEach((discount) => totalRow(discount.title, `−${money(discount.total_allocated_amount)}`, 'is-discount'));
      const saving = comparisonSaving(cart);
      if (saving > 0) totalRow(strings.youSave, money(saving), 'is-savings');
      if (offerActive()) totalRow(strings.shipping, '…').setAttribute('data-shipping-pending', '');
      totalRow(`${strings.total} (${cart.currency})`, offerActive() ? '…' : money(cart.total_price), 'is-total');
      dialog.querySelector('[data-cart-note]').textContent = offerActive() ? strings.loading : (cart.taxes_included ? strings.taxIncluded : strings.note);
      decorateOffer(generation);
      if (focusKey !== undefined && dialog.open) {
        const inputs = [...body.querySelectorAll('[data-cart-key]')];
        const target = inputs.find((input) => input.dataset.cartKey === focusKey.key) || inputs[Math.min(focusKey.index, inputs.length - 1)] || closeButton;
        target.focus({ preventScroll: true });
      }
    };
    const request = async (url, options = {}) => {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, headers: { Accept: 'application/json', ...options.headers } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || strings.error);
      return result;
    };
    const reloadStaleCartPage = () => {
      if (changed && !busy && !dialog.open && location.pathname.replace(/\/$/, '') === config.cartUrl.replace(/\/$/, '')) location.reload();
    };
    const refresh = async () => {
      if (busy) { refreshAfterBusy = true; return; }
      setError();
      setBusy(true);
      try {
        let result = await request(`${config.cartUrl}.js`);
        if (offer && offer.supports(result)) result = await offer.clean(result);
        render(result);
      }
      catch (failure) {
        setError(failure instanceof TypeError ? strings.error : failure.message);
        if (!cart) {
          body.replaceChildren();
          const fallback = node('a', 'button', strings.view);
          fallback.href = config.cartUrl;
          body.append(fallback);
        }
      } finally {
        setBusy(false);
        if (refreshAfterBusy) { refreshAfterBusy = false; refresh(); }
      }
    };
    const change = async (key, quantity, index) => {
      if (busy) return;
      setError();
      setBusy(true);
      let updated = false;
      try {
        const result = await request(config.changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        changed = true;
        render(result, { key, index });
        updated = true;
      } catch (failure) {
        try { render(await request(`${config.cartUrl}.js`), { key, index }); } catch {}
        setError(failure instanceof TypeError ? strings.error : failure.message);
      } finally {
        setBusy(false);
        if (updated) status.textContent = strings.updated;
        if (refreshAfterBusy) { refreshAfterBusy = false; refresh(); }
        reloadStaleCartPage();
      }
    };
    priority?.addEventListener('change', async () => {
      if (busy || priority.dataset.addonPurchasable !== 'true' || !cart?.items.length) { syncPriority(); return; }
      const selected = priority.checked;
      const lines = priorityLines();
      setError();
      setBusy(true);
      try {
        if (selected && !lines.length) {
          await request(config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(priority.dataset.variantId), quantity: 1, properties: { _browfi_addon: 'priority' } }] }) });
        } else if (!selected) {
          for (const line of lines) await request(config.changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
        }
        changed = true;
        render(await request(`${config.cartUrl}.js`));
      } catch (failure) {
        try { render(await request(`${config.cartUrl}.js`)); } catch {}
        setError(failure instanceof TypeError ? strings.error : failure.message);
      } finally {
        setBusy(false);
        if (refreshAfterBusy) { refreshAfterBusy = false; refresh(); }
        reloadStaleCartPage();
      }
    });
    const open = (confirmedCart) => {
      document.querySelectorAll('[data-offer-cart][open]').forEach(panel => panel.close());
      if (!dialog.open) {
        opener = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('source-cart-open');
        closeButton.focus();
      }
      if (confirmedCart?.items && !busy) { setError(); render(confirmedCart); }
      else refresh();
    };
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('source-cart-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      reloadStaleCartPage();
    });
    checkout.closest('form').addEventListener('submit', (event) => { if (busy || !cart?.items.length) event.preventDefault(); });
    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('.header__icon--cart, .mk-cart, [data-cart-open]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      open();
    });
    document.addEventListener('browfi:cart-added', (event) => {
      event.preventDefault();
      changed = true;
      open(event.detail?.cart);
    });
    updateCount(config.count);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
(() => {
  const start = () => {
    const excluded = 'script,style,noscript,textarea,input,select,option,svg,.mk-free-label,[contenteditable="true"]';
    const mark = root => {
      const nodes = [];
      const collect = text => {
        if (text.nodeType === 3 && /\bFREE\b/i.test(text.nodeValue || '') && text.parentElement && !text.parentElement.closest(excluded)) nodes.push(text);
      };
      if (root.nodeType === 3) collect(root);
      else if (root.nodeType === 1 && !root.closest(excluded)) {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) collect(walker.currentNode);
      }
      nodes.forEach(text => {
        const fragment = document.createDocumentFragment();
        const value = text.nodeValue;
        let from = 0;
        for (const match of value.matchAll(/\bFREE\b/gi)) {
          fragment.append(document.createTextNode(value.slice(from, match.index)));
          const badge = document.createElement('span');
          badge.className = 'mk-free-label';
          badge.textContent = match[0];
          fragment.append(badge);
          from = match.index + match[0].length;
        }
        fragment.append(document.createTextNode(value.slice(from)));
        text.replaceWith(fragment);
      });
    };
    document.querySelectorAll('.source-offer,[data-source-cart]').forEach(root => {
      mark(root);
      new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(mark))).observe(root, {childList:true, subtree:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();







